import Button from "components/ui/Button";
import { PricingModelItem, PurchaseStudentType } from "../../services/pricingModel/model";
import Dialog from "components/ui/Dialog";
import PurchasePlan from "../PurchasePlan";
import styles from "./styles.module.scss";
import { CloseRounded } from "@material-ui/icons";

export interface Props {
  onClose: () => void;
  onSuccess: (purchasedItem: PricingModelItem) => void;
  type: PurchaseStudentType;
  backOptionsText?: string;
}

export default function PurchasePlanModal(props: Props) {
  return (
    <Dialog
      open
      hideHeader
      aria-label="Purchase plan"
      className={styles.dialog}
      onClose={props.onClose}
    >
      <Button
        variant="plain"
        Icon={CloseRounded}
        size="extra-large"
        className={styles.closeButton}
        onClick={props.onClose}
      />
      <PurchasePlan
        className={styles.purchasePlan}
        type={props.type}
        onBack={props.onClose}
        onSuccess={props.onSuccess}
      />
    </Dialog>
  );
}
